// 任务管理
import ProjectAdd from './project/PageAdd';
import ProjectDetail from './project/pageDetail/Index';
import ProjectDetailManage from './project/pageDetailManage/Index';
import ProjectInfo from './project/PageInfo';
import ProjectWatch from './project/PageWatch';
import ProjectLaunch from './project/PageLaunch';
import ProjectReceive from './project/PageReceive';
import TaskAdd from './spTask/PageAdd';
import TaskDetail from './spTask/pageDetail/Index';
import TaskCheckDetail from './taskCheck/PageInfo';
import TaskSubmit from './spTask/PageSubmit';
import TaskWatch from './spTask/PageWatch';
import TaskLaunch from './spTask/PageLaunch';
import TaskReceive from './spTask/PageReceive';
import TaskCheckMine from './taskCheck/PageMine';
import TaskCheckWatch from './taskCheck/PageWatch';

const router = {
  path: 'task',
  breadcrumbName: '任务',
  childRoutes: [
    {
      path: 'project_add',
      breadcrumbName: '新增项目',
      component: ProjectAdd,
    },
    {
      path: 'project_edit/:uuid',
      breadcrumbName: '编辑项目',
      component: ProjectAdd,
    },
    {
      path: 'project_detail_manage/:uuid',
      breadcrumbName: '项目详情',
      component: ProjectDetailManage,
    },
    {
      path: 'project_detail/:uuid',
      breadcrumbName: '项目详情',
      component: ProjectDetail,
    },
    {
      path: 'project_detail_finish/:uuid',
      breadcrumbName: '项目详情',
      component: ProjectDetail,
    },
    {
      path: 'project_info/:uuid',
      breadcrumbName: '项目详情',
      component: ProjectInfo,
    },
    {
      path: 'project_watch',
      breadcrumbName: '项目监控',
      component: ProjectWatch,
    },
    {
      path: 'project_launch',
      breadcrumbName: '项目管理',
      component: ProjectLaunch,
    },
    {
      path: 'project_receive',
      breadcrumbName: '收到的项目',
      component: ProjectReceive,
    },
    {
      path: 'project_task_add',
      breadcrumbName: '新增任务',
      component: TaskAdd,
    },
    {
      path: 'task_add',
      breadcrumbName: '新增任务',
      component: TaskAdd,
    },
    {
      path: 'project_task_edit/:taskUuid',
      breadcrumbName: '编辑任务',
      component: TaskAdd,
    },
    {
      path: 'task_edit/:taskUuid',
      breadcrumbName: '编辑任务',
      component: TaskAdd,
    },
    {
      path: 'task_submit/:uuid',
      breadcrumbName: '提交任务',
      component: TaskSubmit,
    },
    {
      path: 'task_detail/:uuid',
      breadcrumbName: '任务详情',
      component: TaskDetail,
    },
    {
      path: 'task_check_detail/:uuid',
      breadcrumbName: '任务审核详情',
      component: TaskCheckDetail,
    },
    {
      path: 'task_watch',
      breadcrumbName: '任务监控',
      component: TaskWatch,
    },
    {
      path: 'task_launch',
      breadcrumbName: '任务管理',
      component: TaskLaunch,
    },
    {
      path: 'task_check_mine',
      breadcrumbName: '任务审核',
      component: TaskCheckMine,
    },
    {
      path: 'task_check_watch',
      breadcrumbName: '任务审核监控',
      component: TaskCheckWatch,
    },
    {
      path: 'task_receive',
      breadcrumbName: '收到的任务',
      component: TaskReceive,
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/task/router.js